import { render } from "./AddNewService.vue?vue&type=template&id=4d1e87ae"
import script from "./AddNewService.vue?vue&type=script&lang=js"
export * from "./AddNewService.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__